import { render, staticRenderFns } from "./MenuControls.vue?vue&type=template&id=b33da33a&"
import script from "./MenuControls.vue?vue&type=script&lang=js&"
export * from "./MenuControls.vue?vue&type=script&lang=js&"
import style0 from "./MenuControls.vue?vue&type=style&index=0&id=b33da33a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports